import { CountryCode } from "@/custom-types/CountryCode";
import { RetailType } from "@/custom-types/Store";

interface Breadcrumb {
  countryCode: CountryCode;
  finderRoute: string;
  storeRoute: string;
  title: string;
  type: RetailType;
}

type BreadcrumbConfig = Record<CountryCode, Record<RetailType, Breadcrumb>>;

export default [
  {
    countryCode: "CA",
    finderRoute: "/cbd-stores",
    storeRoute: "/cbd-store/",
    title: "CBD",
    type: "cbd-store",
  },
  {
    countryCode: "US",
    finderRoute: "/cbd-stores",
    storeRoute: "/cbd-store/",
    title: "CBD",
    type: "cbd-store",
  },
  {
    countryCode: "CA",
    finderRoute: "/medical-marijuana-doctors",
    storeRoute: "/doctors/",
    title: "Doctors",
    type: "clinic",
  },
  {
    countryCode: "US",
    finderRoute: "/medical-marijuana-doctors",
    storeRoute: "/doctors/",
    title: "Doctors",
    type: "clinic",
  },
  {
    countryCode: "CA",
    finderRoute: "/dispensaries",
    storeRoute: "/cannabis-store/",
    title: "Stores",
    type: "dispensary",
  },
  {
    countryCode: "US",
    finderRoute: "/dispensaries",
    storeRoute: "/dispensary-info/",
    title: "Dispensaries",
    type: "dispensary",
  },
];

export const breadcrumbConfig: BreadcrumbConfig = {
  CA: {
    "cbd-store": {
      countryCode: "CA",
      finderRoute: "/cbd-stores",
      storeRoute: "/cbd-store/",
      title: "CBD",
      type: "cbd-store",
    },
    clinic: {
      countryCode: "CA",
      finderRoute: "/medical-marijuana-doctors",
      storeRoute: "/doctors/",
      title: "Doctors",
      type: "clinic",
    },
    dispensary: {
      countryCode: "CA",
      finderRoute: "/dispensaries",
      storeRoute: "/cannabis-store/",
      title: "Stores",
      type: "dispensary",
    },
  },
  US: {
    "cbd-store": {
      countryCode: "US",
      finderRoute: "/cbd-stores",
      storeRoute: "/cbd-store/",
      title: "CBD",
      type: "cbd-store",
    },
    clinic: {
      countryCode: "US",
      finderRoute: "/medical-marijuana-doctors",
      storeRoute: "/doctors/",
      title: "Doctors",
      type: "clinic",
    },
    dispensary: {
      countryCode: "US",
      finderRoute: "/dispensaries",
      storeRoute: "/dispensary-info/",
      title: "Dispensaries",
      type: "dispensary",
    },
  },
};
